<template lang="pug">
  #games
    .game-profile(:style="bgImage")
      .bg(:style="bgImage")
      nav(:style="navStyle")
        nav
          a.link(href="/")
            span(:style="linkStyle") Go Back
        GameProfileNav(:iconSrc="iconSrc" :colors="game.colors")
      .content
        GameSummary(:game="game")
</template>

<script>
import games from '@/data/games.json'
import GameProfileNav from '@/components/GameProfileNav.vue'
import GameSummary from '@/components/GameSummary.vue'

export default {
  name: "Games",
  components: {
    GameProfileNav,
    GameSummary
  },
  data() {
    return {
      game: games.games[this.$route.params.slug]
    }
  },
  computed: {
    bgImage() {
      const rgb = this.hexToRGB(this.game.colors.base)
      return {
        backgroundImage: `linear-gradient(to top, rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 1), rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0)), url(/assets/games/${this.game.slug}/${this.game.assets.gif})`,
      }
    },
    videoSource() {
      return `/assets/games/${this.game.slug}/${this.game.assets.video}`
    },
    iconSrc() {
      return `/assets/games/${this.game.slug}/${this.game.assets.icon}`
    },
    linkStyle() {
      return {
        '--color': this.game.colors.muted,
        '--color-hover': this.game.colors.text
      }
    },
    navStyle() {
      const rgb = this.hexToRGB(this.game.colors.base)
      return {
        background: `linear-gradient(to bottom, rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 1), rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.8), rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0))`
      }
    }
  },
  methods: {
    hexToRGB(hex) {
      const rgbArray = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return rgbArray ? {
        r: parseInt(rgbArray[1], 16),
        g: parseInt(rgbArray[2], 16),
        b: parseInt(rgbArray[3], 16)
      } : null;
    }
  },
}
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css2?family=Oxanium:wght@200;300;400;500;600;700;800&display=swap')

a
  cursor-pointer()
  
.game-profile
  background-position center
  background-repeat no-repeat
  background-size cover
  position relative
  width 100vw
  height 100vh
  > .bg
    background-position center
    background-repeat no-repeat
    background-size cover
    filter blur(sm2)
    position absolute
    top 0
    left 0
    width 100%
    height 100vh
  > nav 
    backdrop-filter blur(sm1)
    -webkit-backdrop-filter blur(sm1)
    bs2(rgba(black, 0.6))
    padding-top sp2
    position fixed
    top 0
    left 0
    right 0
    z-index 10
    > nav 
      display flex
      justify-content flex-end
      margin-bottom sp1
      width "calc(100% - %s)" % sp2
      @media (min-width: 1280px)
        margin 0 auto sp1
        max-width 1280px
        > a.link
          margin-right sp2
      > a.link 
        text-decoration none
        > span
          color var(--color)
          font-size tm1
          font-weight 600
          transition all 0.2s ease-in-out
          &:hover
            color var(--color-hover)
  > .content
    overflow-y scroll
    position absolute
    width 100%
    height 100vh
</style>